@if (magicSearchService.forYouSearchResults() && magicSearchService.forYouSearchResults()!.length > 0) {
<div class="w-full h-full overflow-y-auto min-h-0 scrollbar-hide">

    <div class="w-full p-2">
        <ul role="list" class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">
            @for (creator of magicSearchService.forYouSearchResults()!; track $index) {
                <li class="card-animate" [style.animation-delay]="($index * 0.1) + 's'">
                    <cv2-creator-card-pink [creator]="creator"></cv2-creator-card-pink>
                </li>
            }
        </ul>
    </div>
</div>
}